import React, { useState, useEffect } from 'react';
import './section8.css';
import img1 from '../../asserts/vd-img.png';
import imgg1 from '../../asserts/vd5-img.png';
import imggg1 from '../../asserts/vd2-img.png';
import imgggg1 from '../../asserts/vd3-img.png';
import imgggggg1 from '../../asserts/vd4-img.png';
import Title from '../common/title';
import Text from '../common/text';
import Btn from '../common/btn';

const images = [img1, imgg1, imggg1, imgggg1, imgggggg1];

const Section8 = () => {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent(prev => (prev + 1) % images.length);
        }, 4000);
        return () => clearInterval(interval);
    }, []); 
    // I looked this up on the internet and applied it.

    return (
        <section className='sec8-contanier'>

            <div className="sec8-image">
                {images.map((img, index) => (
                    <img
                        key={index}
                        src={img}
                        alt={`Golden Hills Villa ${index + 1}`}
                        className={`sec8-img ${index === current ? 'active' : ''}`}
                    />
                ))}
            </div>

            <div className="sec8-content-wrapper">
                <div className="sec8-card sec8-card-top waves-bg">
                    <div className="sec8-card-inner">
                        <Title title='Welcome to Golden Hills Villas' t='title' />
                        <Text text="Modern Living, Elevated" x='text' />
                    </div>
                </div>

                <div className="sec8-card sec1-card-bottom">
                    <div className="sec8-card-inner">
                        <Text text="Golden Hills Apartments offer the perfect blend of style, comfort, and convenience. Designed for urban lifestyles, our apartments feature contemporary interiors, thoughtful layouts, and prime locations. Experience a home that fits your needs and enhances your daily life." x='text' />
                        <Btn btn='Explore Now' />
                    </div>
                </div>
            </div>

        </section>
    );
};

export default Section8;